/**
 * Regular expression patterns for input validation
 */
export const VALIDATION_PATTERNS = {
  NUMERIC_ONLY: '[0-9]*',
  EMAIL: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
  PHONE: '^[+]?[1-9]\\d{1,14}$',
  ALPHANUMERIC: '^[a-zA-Z0-9]*$',
  PASSWORD_STRONG: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])',
  POSTAL_CODE: '^[A-Za-z0-9\\s-]{3,10}$',
  USERNAME: '^[a-zA-Z0-9_-]{3,20}$',
  CODE_NUMERIC: '^\\d{6}$',
} as const;

/**
 * Regex objects for validation
 */
export const VALIDATION_REGEX = {
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
  CODE: /^\d{6}$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^[+]?[1-9]\d{1,14}$/,
  PO_BOX:
    /\b(P[\W_]*(?:O|0)[\W_]*\W?B(?:O|0)X|P\.?\s*(?:O|0)\.?\s*B(?:O|0)X|P(?:O|0)\s+B(?:O|0)X|POST\s*OFFICE\s*B(?:O|0)X|POB|APARTADO\s+POSTAL|APARTADO(?!\s+NACIONAL)|APDO\.?|CASILLA|APARTADO\s+DE\s+CORREOS|CORREO\s+POSTAL|BUZON\s+POSTAL|LISTA\s+DE\s+CORREOS|CORREOS\s+DE\s+MEXICO|SEPOMEX)\b/iu,
} as const;

export type ValidationPattern =
  (typeof VALIDATION_PATTERNS)[keyof typeof VALIDATION_PATTERNS];
